import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Button from 'react-bootstrap/Button'

export class NotFound extends Component {
    render() {
        return (
            <div className="not-found">
                <h1>404 - PAGE NOT FOUND</h1>
                <h5>The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</h5>
                <Link to='/'>
                    <button type="button">GO TO HOMEPAGE</button>
                </Link>
            </div>
        )
    }
}

export default NotFound
